export default "__VITE_ASSET__CCsFep7d__"